import * as React from 'react'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Collapse from '@mui/material/Collapse'
import useTheme from '@mui/material/styles/useTheme'

import { AgreementClosingRequirementsProps } from '../../typings'
import { ClosingRequirementCheckbox } from '../../atoms/ClosingRequirementCheckbox'
import { useData, useHandlers } from './hooks'

export const AgreementsRequirement: React.FC<
  AgreementClosingRequirementsProps
> = (props) => {
  const { onSelected, ...model } = props

  const data = useData(model)
  const { onCheckedUnChecked } = useHandlers(data, onSelected)
  const {
    disabled,
    disableAutoClose,
    requirement,
    autoCloseWinTitle,
    autoCloseWinLeadsTitle,
  } = data

  const theme = useTheme()

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          mt: theme.spacing(2),
          width: '100%',
          maxWidth: '100%',
        }}
      >
        <Typography variant="subtitle1">
          Sales Funnel: {requirement.salesFunnelName}
        </Typography>
      </Box>

      <ClosingRequirementCheckbox
        label="Require Agreement to close/win"
        name="requireAgreement"
        checked={requirement.requireAgreement}
        onChange={onCheckedUnChecked}
      />

      <Collapse in={!disabled}>
        <ClosingRequirementCheckbox
          label="Require Agreement to be signed by customer to Close/Win"
          name="requireCustomerSignature"
          checked={requirement.requireCustomerSignature}
          onChange={onCheckedUnChecked}
          disabled={disabled}
        />

        <ClosingRequirementCheckbox
          label="Auto-Close/Win Leads upon Customer Signature"
          name="autoCloseWinLeads"
          checked={requirement.autoCloseWinLeads}
          onChange={onCheckedUnChecked}
          disabled={disableAutoClose}
          tooltip={autoCloseWinLeadsTitle}
        />

        <ClosingRequirementCheckbox
          label="Auto-Close/Win Opportunities upon Customer Signature"
          name="autoCloseWinOpportunities"
          checked={requirement.autoCloseWinOpportunities}
          onChange={onCheckedUnChecked}
          disabled={disableAutoClose}
          tooltip={autoCloseWinTitle}
        />
      </Collapse>
    </>
  )
}
